import { inject, OnDestroy, OnInit, Directive } from '@angular/core';
import {
  AlertController,
  IonContent,
  ModalController,
  NavController
} from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  KeyboardBridgeService,
  LoadingService,
  NotificationService
} from '../services';
import { Router } from '@angular/router';
import {TranslateService} from "@ngx-translate/core";

@Directive()
export abstract class BaseFormAbstractPage implements OnInit, OnDestroy {
  protected modalCtrl = inject(ModalController);
  protected router = inject(Router);
  protected navCtrl = inject(NavController);
  protected alertController = inject(AlertController);
  protected loadingService = inject(LoadingService);
  protected notificationService = inject(NotificationService);
  protected translate = inject(TranslateService);

  abstract content: IonContent;
  /**
   * @protected
   */
  protected scrollOnFocus = true;

  protected destroy$ = new Subject<void>();
  private activeElement: HTMLElement | null = null;
  private keyboardBridge = inject(KeyboardBridgeService);

  ngOnInit(): void {
    if (!this.scrollOnFocus) {
      return;
    }

    this.keyboardBridge.keyboardWillShow
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.scrollToActiveInput();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * @param event
   */
  public onInputFocus(event: Event): void {
    this.activeElement = event.target as HTMLElement;
  }

  private scrollToActiveInput(): void {
    if (!this.activeElement) {
      return;
    }

    setTimeout(() => {
      if (this.content) {
        this.content.scrollToPoint(0, this.activeElement!.offsetTop - 20, 300);
      }
    }, 250);
  }
}
